__turbopack_context__.v({
  "buy": "DeskChip-module__joecjG__buy",
  "chip": "DeskChip-module__joecjG__chip",
  "default": "DeskChip-module__joecjG__default",
  "error": "DeskChip-module__joecjG__error",
  "primary": "DeskChip-module__joecjG__primary",
  "sell": "DeskChip-module__joecjG__sell",
  "success": "DeskChip-module__joecjG__success",
  "warning": "DeskChip-module__joecjG__warning",
});
